import React, { Component } from "react";
import PropTypes from "prop-types";
import Divider from "@material-ui/core/Divider";
import Link from "@material-ui/core/Link";
import * as Theme from "../../../app/Theme";
import * as HLConst from "../NonVisual/HLConst";
import HLNavBtnDiv from "../Other/HLNavBtnDiv";
import image from "../../../img/mother with kids.jpg";

class HLStep5Form extends Component {
    static propTypes = {
        onPageChange: PropTypes.func,
    };

    static defaultProps = {
        onPageChange: () => console.log("onPageChange"),
    };

    //==================================================================================================================
    //
    //                                              Event Handlers
    //
    //==================================================================================================================

    onPageChange = (pageID) => {
        this.props.onPageChange(pageID);
    };

    onTemplatesClick = () => {
        window.open("./resources/" + HLConst.templatesXLSX, "_blank");
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    renderTextDiv = () => {
        let textDiv = (
            <div
                style={{
                    ...Theme.textFontStyle,
                    // backgroundColor : Theme.HL_PrimaryColor,
                    // color           : "white",
                    marginLeft: Theme.leftIndent,
                }}
            >
                <p
                    style={{
                        ...Theme.pageHeadingFontStyle,
                        ...Theme.pageHeadingWithBannerStyle,
                    }}
                >
                    {HLConst.step5AreaText1}
                    &nbsp;
                    {/*<span style = {Theme.stepSubTextHeadingFontStyle}>*/}
                    {HLConst.step5AreaText2}
                    {/*</span>*/}
                </p>

                <Divider
                    style={{
                        ...Theme.dividerStyle,
                    }}
                />

                <p>
                    Assess the feasibility of implementing your chosen activities and improving coverage of these
                    interventions given:
                </p>

                <ul>
                    <li>Cost</li>
                    <li>Implementation-related challenges</li>
                    <li>
                        Timeline: some interventions you can change in short-term and some require longer term planning
                    </li>
                    <li>Repeated but unsuccessful past attempts at improving coverage</li>
                    <li
                        style={{
                            marginLeft: Theme.bulletListIndent2,
                        }}
                    >
                        e.g. Bednet usage
                    </li>
                    <li>Service delivery problems that are outside of your control</li>
                    <li>Supply chain issues</li>
                </ul>

                <p>
                    Make note of your feasibility assessment decision using&nbsp;
                    <Link
                        onClick={this.onTemplatesClick}
                        style={{
                            color: Theme.HL_LinkBlue,
                            cursor: "pointer",
                        }}
                        underline={"hover"}
                    >
                        our template
                    </Link>
                    .
                </p>

                <div
                    style={{
                        ...Theme.exampleDivStyle,
                    }}
                >
                    <p>
                        <span
                            style={{
                                textDecoration: "underline",
                            }}
                        >
                            For example:
                        </span>
                        &nbsp;Although the most life-saving intervention in your setting is treatment of MAM and you
                        would like to increase distribution of ready-to-use supplemental food, this is a program jointly
                        implemented with other partners who face implementation-related challenges that are outside your
                        control. It is unlikely you will be able to access enough ready-to-use supplemental foods to
                        increase distribution.
                    </p>
                </div>
            </div>
        );

        return textDiv;
    };

    render() {
        const navBtnDiv = (
            <HLNavBtnDiv
                onBackBtnClick={() => this.onPageChange(HLConst.step4Form)}
                onNextBtnClick={() => this.onPageChange(HLConst.step6Form)}
            />
        );

        return (
            <div
                style={{
                    minHeight: window.innerHeight - Theme.HL_FooterOffset, //Theme.HL_FooterPosition,
                }}
            >
                <img
                    style={{
                        width: "calc(100% - 1px)",
                    }}
                    src={image}
                    alt=""
                />

                {this.renderTextDiv()}
                {/*{downloadGuideBtn}*/}
                {navBtnDiv}
            </div>
        );
    }
}

export default HLStep5Form;
